import { Controller } from "@hotwired/stimulus"

// The sidebar is a slim rail that opens on hover/focus (pure CSS) unless it is
// pinned open. Pinned state is a class on <html>, set before first paint by an
// inline script in the layout, so this controller only flips and remembers it.
export default class extends Controller {
  static targets = ["pin"]

  connect() {
    this.sync()
  }

  togglePin() {
    const pinned = document.documentElement.classList.toggle("sidebar-pinned")
    try { localStorage.setItem("sidebar_pinned", pinned) } catch (_) { /* storage unavailable */ }
    this.sync()
  }

  // "[" pins/unpins, unless the person is typing somewhere
  shortcut(event) {
    if (event.key !== "[" || event.metaKey || event.ctrlKey || event.altKey) return
    const el = event.target
    if (el.closest?.("input, textarea, select, [contenteditable='true']")) return

    event.preventDefault()
    this.togglePin()
  }

  sync() {
    if (!this.hasPinTarget) return
    const pinned = document.documentElement.classList.contains("sidebar-pinned")
    this.pinTarget.setAttribute("aria-pressed", pinned)
    this.pinTarget.setAttribute("aria-label", pinned ? "Unpin sidebar" : "Pin sidebar open")
    this.pinTarget.title = pinned ? "Unpin sidebar ( [ )" : "Pin sidebar open ( [ )"
    this.pinTarget.querySelector("i").className = pinned ? "bi bi-pin-angle-fill" : "bi bi-pin-angle"
  }
}
